import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Button, CircularProgress, IconButton, Paper } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import { MdAdd } from 'react-icons/md';
import usePagebuilder from '../../../../hooks/pagebuilder/usePagebuilder';
import { SpeakerEntry } from '../../../../interfaces/pagebuilder';
import { fetchAndSetEventSpeakers, setPBSpeakersModalComponent, setSpeakerModal } from '../../../../reduxToolkit/slices/commonSlice';
import { useSelector, useDispatch } from '../../../../reduxToolkit/typedRedux';
import { createSpeaker, deleteSpeaker } from '../../../../services/services';
import { VyConfirm } from '../../../common/VyConfirm';
import VyModal from '../../../common/VyModal';
import VyNoData from '../../../common/VyNoData';
import VyTooltip from '../../../common/VyTooltip';
import SpeakerForm from '../Settings/speakers/SpeakerSettings/SpeakerForm';

const PBSpeakersModal = ({ onClose }: { onClose: () => void }) => {
  const event = useSelector((state) => state.common.event);
  const uiComponent = useSelector((state) => state.common.PBSpeakersModalComponent);
  const eventSpeakers = useSelector((state) => state.common.eventSpeakers);

  const { t } = useTranslation();
  const { editComponent } = usePagebuilder();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [isCreateModal, setIsCreateModal] = useState(false);

  async function _deleteSpeaker(id: string) {
    setLoading(true);
    try {
      await deleteSpeaker(id);
      dispatch(fetchAndSetEventSpeakers(event!._id));
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  }
  const selectSpeaker = (id: string) => {
    // TODO: Dispatch here
    const speaker = eventSpeakers?.find((s) => s._id === id);

    if (speaker) {
      dispatch(
        setSpeakerModal({
          speaker,
        })
      );
    }
  };

  const addSpeakerToComponent = (speaker: SpeakerEntry) => {
    if (!uiComponent) return;
    const component = { ...uiComponent };
    component.entryIds = [...component.entryIds, { ...speaker, position: component.entryIds.length + '' }];
    editComponent(component);
    dispatch(setPBSpeakersModalComponent(component));
  };

  async function handleCreateSpeaker(props: SpeakerEntry) {
    if (!event) return;
    if (!uiComponent) return;
    delete props._id;
    const speaker = await createSpeaker(event?._id, props);
    dispatch(fetchAndSetEventSpeakers(event._id));
    addSpeakerToComponent(speaker);
  }

  return (
    <VyModal open={true} maxWidth={'100cqw'} onClose={onClose} hasDefaultPadding={false}>
      {(onClose) => (
        <div>
          <div className="flex flex-row items-center justify-between w-full p-4 space-x-2">
            <p className="text-xl font-bold">{t('pagebuilder:speakers')}</p>
            {eventSpeakers && eventSpeakers?.length > 0 && (
              <VyTooltip title={t('pagebuilder:add-new-entry')}>
                <Button onClick={() => setIsCreateModal(true)}>
                  <MdAdd size="20" />
                </Button>
              </VyTooltip>
            )}
          </div>
          <Paper style={{ padding: '12px', minWidth: '20cqw' }}>
            {loading ? (
              <div className="grid p-8 place-items-center">
                <CircularProgress />
              </div>
            ) : eventSpeakers && eventSpeakers?.length > 0 ? (
              <>
                {eventSpeakers?.map((s) => (
                  <div className="flex flex-row items-center justify-between w-full px-4 py-2 space-x-4 transition-colors bg-white hover:bg-slate-50">
                    <b>{s.name}</b>
                    <div className="flex flex-row space-x-1">
                      <IconButton onClick={() => s._id && selectSpeaker(s._id)} edge="end" aria-label="delete" size="large">
                        <VisibilityIcon />
                      </IconButton>
                      {!uiComponent?.entryIds.map((sp) => sp._id).includes(s._id) && (
                        <VyTooltip title={t('pagebuilder:add-speaker')}>
                          <IconButton onClick={() => !!s && addSpeakerToComponent(s)} edge="end" aria-label="delete" size="large">
                            <AddIcon />
                          </IconButton>
                        </VyTooltip>
                      )}
                      <VyConfirm warningText={t('pagebuilder:delete-speaker-warning')} onConfirm={() => s._id && _deleteSpeaker(s._id)}>
                        <IconButton edge="end" aria-label="delete" size="large">
                          <DeleteIcon />
                        </IconButton>
                      </VyConfirm>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className="p-10">
                <VyNoData onCreate={() => setIsCreateModal(true)} withCreate createText={t('pagebuilder:entry-add')} />
              </div>
            )}

            {isCreateModal && (
              <SpeakerForm onSpeakerCreated={handleCreateSpeaker} isModal isModalOpen={isCreateModal} onCloseModal={() => setIsCreateModal(false)} />
            )}
          </Paper>
        </div>
      )}
    </VyModal>
  );
};
export default PBSpeakersModal;
